import {
  meetingFromDto,
  studentFromDto,
} from "./studentMeetingMyStudents.mapper";
import type {
  MeetingLessonGroup,
  MeetingLessonGroupDto,
  MeetingMyLessonGroupsOverview,
  MeetingMyLessonGroupsOverviewDto,
} from "meetings/student-meeting/types";

const lessonGroupFromDto = (
  dto: MeetingLessonGroupDto,
): MeetingLessonGroup => ({
  name: dto.name,
  lessonClass: dto.lesson_class,
  subject: dto.subject,
  teacherShortage: dto.teacher_shortage,
  students: dto.students.map(studentFromDto),
});

export const myLessonGroupsOverviewFromDto = (
  dto: MeetingMyLessonGroupsOverviewDto,
): MeetingMyLessonGroupsOverview => ({
  meeting: meetingFromDto(dto.meeting),
  lessonGroups: dto.lesson_groups.map(lessonGroupFromDto),
  meta: {
    hasMore: dto.meta.has_more,
    offset: dto.meta.offset,
    take: dto.meta.take,
    total: dto.meta.total,
  },
  enableStudentFilter: dto.enable_student_filter,
});
